import _ from "lodash";
import { ValidationProvider } from "vee-validate/dist/vee-validate.full";

export default {
  name: "bselect",
  components: {
    ValidationProvider
  },
  props: [
    "items",
    "label",
    "title",
    "nameProp",
    "selected",
    "order",
    "validation",
    "nameInjection"
  ],
  data() {
    return {
      visible: false,
      showError: false,
      selectedInited: false,
      itemsInited: false,
      disableProvider: false
    };
  },
  computed: {
    orderedItems: function() {
      if (this.items) {
        return _.orderBy(this.items, this.order);
      }
    }
  },
  watch: {
    selected: function(newObj, oldObj) {
      if (!this.selectedInited) {
        this.UpdateValue(newObj);
        this.selectedInited = true;
        this.disableProvider = true;
      }
    }
  },
  mounted() {
    this.$refs["validationProvider"].applyResult({
      errors: [],
      valid: false
    });

    if (this.selected) {
      this.UpdateValue(this.selected);
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.OutsideClick);
  },
  methods: {
    Show() {
      if (!this.visible) {
        document.addEventListener("click", this.OutsideClick);
      }

      this.$set(this, "visible", !this.visible);
    },

    OutsideClick(event) {
      let ddl = this.$refs["BSelect"];
      if (!ddl.contains(event.target)) {
        this.visible = false;
        document.removeEventListener("click", this.OutsideClick);
      }
    },
    UpdateValue(obj) {
      document.removeEventListener("click", this.OutsideClick);

      this.$nextTick(() => {
        this.$emit("selected", obj);
        this.$emit("title", this.$helpers.GetProp(obj, this.nameProp));

        for (let item of this.items) {
          item.selected = false;
        }

        obj.selected = true;

        this.$refs["validationProvider"].applyResult({
          errors: [],
          valid: true
        });

        this.disableProvider = true;
        this.selectedInited = true;
      });
    }
  }
};
